export function getLineRotation(line: number[]) {
  const [x1, y1, x2, y2] = line;

  const radians = Math.atan2(y2 - y1, x2 - x1);

  return radians * (180 / Math.PI);
}
